import { render } from "./EvolutionFormModal.vue?vue&type=template&id=bc8d7104&scoped=true&ts=true&lang=pug"
import script from "./EvolutionFormModal.vue?vue&type=script&lang=ts"
export * from "./EvolutionFormModal.vue?vue&type=script&lang=ts"

import "./EvolutionFormModal.vue?vue&type=style&index=0&id=bc8d7104&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc8d7104"]])

export default __exports__